/**
 * Grill King single showroom page — loads ?view_store= alias.
 */
(function () {
  const root = document.querySelector('[data-egj-location-detail]');
  if (!root) return;

  const apiUrl = root.getAttribute('data-api-url');
  const fallbackUrl = root.getAttribute('data-fallback-url');
  const params = new URLSearchParams(window.location.search);
  const alias = (params.get('view_store') || '').trim();

  const els = {
    name: root.querySelector('[data-egj-loc-name]'),
    state: root.querySelector('[data-egj-loc-state]'),
    address: root.querySelector('[data-egj-loc-address]'),
    addressCard: root.querySelector('[data-egj-loc-address-card]'),
    phone: root.querySelector('[data-egj-loc-phone]'),
    phoneWrap: root.querySelector('[data-egj-loc-phone-wrap]'),
    call: root.querySelector('[data-egj-loc-call]'),
    email: root.querySelector('[data-egj-loc-email]'),
    emailWrap: root.querySelector('[data-egj-loc-email-wrap]'),
    hours: root.querySelector('[data-egj-loc-hours]'),
    today: root.querySelector('[data-egj-loc-today]'),
    directions: root.querySelector('[data-egj-loc-directions]'),
    directionsAlt: root.querySelector('[data-egj-loc-directions-alt]'),
    map: root.querySelector('[data-egj-loc-map]'),
    mapFallback: root.querySelector('[data-egj-loc-map-fallback]'),
    mapCta: root.querySelector('[data-egj-loc-map-cta]'),
    status: root.querySelector('[data-egj-loc-status]'),
  };

  function markReady() {
    root.dataset.ready = '1';
    root.dispatchEvent(new CustomEvent('egj:location-ready'));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function phoneHref(phone) {
    return String(phone || '').replace(/[^\d+]/g, '');
  }

  function normalizeList(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.locations)) return data.locations;
    return [];
  }

  function mergeThemeSchedules(apiList, themeList) {
    if (!themeList.length) return apiList;
    const byAlias = {};
    themeList.forEach((loc) => {
      if (loc && loc.alias) byAlias[loc.alias] = loc;
    });
    return apiList.map((loc) => {
      const themeLoc = loc && loc.alias ? byAlias[loc.alias] : null;
      if (!themeLoc) return loc;
      const overrides = {};
      if (Array.isArray(themeLoc.schedules)) overrides.schedules = themeLoc.schedules;
      if (themeLoc.direction) overrides.direction = themeLoc.direction;
      if (themeLoc.latitude != null && themeLoc.longitude != null) {
        overrides.latitude = themeLoc.latitude;
        overrides.longitude = themeLoc.longitude;
      }
      return Object.assign({}, loc, overrides);
    });
  }

  function applyEditorHours(list) {
    const el = document.getElementById('gk-showroom-hours');
    if (!el || !list.length) return list;
    let map = null;
    try {
      map = JSON.parse(el.textContent);
    } catch (e) {
      return list;
    }
    if (!map || typeof map !== 'object') return list;
    return list.map((loc) => {
      const schedules = loc && loc.alias ? map[loc.alias] : null;
      if (!Array.isArray(schedules) || !schedules.length) return loc;
      return Object.assign({}, loc, { schedules: schedules });
    });
  }

  async function fetchList(url) {
    if (!url) return [];
    const res = await fetch(url + (url.includes('?') ? '&' : '?') + 'cb=' + Date.now(), {
      cache: 'no-store',
    });
    if (!res.ok) return [];
    return normalizeList(await res.json());
  }

  async function loadLocations() {
    let list = [];
    try {
      const apiList = await fetchList(apiUrl);
      if (apiList.length) {
        const themeList = await fetchList(fallbackUrl);
        list = mergeThemeSchedules(apiList, themeList);
      }
    } catch (e) {
      /* fall through */
    }
    if (!list.length) {
      try {
        list = await fetchList(fallbackUrl);
      } catch (e) {
        list = [];
      }
    }
    return applyEditorHours(list);
  }

  function todayName() {
    try {
      return new Date().toLocaleDateString('en-AU', {
        timeZone: 'Australia/Sydney',
        weekday: 'long',
      });
    } catch (e) {
      return '';
    }
  }

  function renderHours(schedules) {
    if (!els.hours) return;
    if (!Array.isArray(schedules) || !schedules.length) {
      els.hours.innerHTML = '<p class="egj-location-detail__empty">Hours available on request.</p>';
      return;
    }
    const today = todayName();
    const match = schedules.find((s) => s.name === today);
    const todayValue = match ? String(match.value || '').trim() : '';
    const isClosed = /^closed$/i.test(todayValue);
    if (els.today) {
      els.today.innerHTML = match
        ? `<span>Today</span> ${escapeHtml(todayValue)}`
        : '';
    }
    if (els.status) {
      els.status.hidden = !todayValue;
      els.status.classList.toggle('is-open', !!todayValue && !isClosed);
      els.status.classList.toggle('is-closed', isClosed);
      els.status.innerHTML = `<i aria-hidden="true"></i>${
        isClosed ? 'Closed today' : `Open today · ${escapeHtml(todayValue)}`
      }`;
    }
    els.hours.innerHTML = schedules
      .map((s) => {
        const isToday = s.name === today;
        const todayTag = isToday ? '<span class="egj-location-detail__today-tag">Today</span>' : '';
        return `<div class="egj-location-detail__hour-row${isToday ? ' is-today' : ''}" data-loc-row><span class="egj-location-detail__hour-day">${escapeHtml(s.name)}${todayTag}</span><span class="egj-location-detail__hour-value">${escapeHtml(s.value)}</span></div>`;
      })
      .join('');
  }

  function setMap(loc) {
    const lat = Number(loc.latitude);
    const lng = Number(loc.longitude);
    // External API may supply direction — allow only http(s) maps URLs.
    let direction = '';
    try {
      const raw = String(loc.direction || '').trim();
      if (raw) {
        const parsed = new URL(raw, window.location.origin);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
          direction = parsed.href;
        }
      }
    } catch (e) {
      direction = '';
    }

    const fallbackMaps =
      Number.isFinite(lat) && Number.isFinite(lng)
        ? `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
        : '#';

    if (els.directions) {
      els.directions.href = direction || fallbackMaps;
    }
    if (els.directionsAlt) {
      els.directionsAlt.href = els.directions?.href || '#';
    }
    if (els.mapCta) {
      els.mapCta.href = direction || fallbackMaps;
    }

    if (els.map && Number.isFinite(lat) && Number.isFinite(lng)) {
      els.map.src = `https://maps.google.com/maps?q=${encodeURIComponent(lat + ',' + lng)}&z=15&output=embed`;
      if (els.mapFallback) els.mapFallback.hidden = true;
    } else if (els.mapFallback) {
      els.mapFallback.hidden = false;
    }
  }

  function render(loc) {
    const phone = loc.phone_number || '1300 305 616';
    const tel = phoneHref(phone);
    const email = loc.email || 'hello@grillkingbbqs.au';
    const state = (loc.state_code || '').toUpperCase();

    if (els.name) els.name.textContent = loc.name || 'Showroom';
    if (els.state) els.state.textContent = state ? `${state} showroom` : 'Showroom';
    if (els.address) els.address.textContent = loc.address || '';
    if (els.addressCard) els.addressCard.textContent = loc.address || '';
    if (els.phone) els.phone.textContent = phone;
    if (els.phoneWrap) els.phoneWrap.href = `tel:${tel}`;
    if (els.call) {
      els.call.href = `tel:${tel}`;
      els.call.textContent = 'Call showroom';
    }
    if (els.email) els.email.textContent = email;
    if (els.emailWrap) els.emailWrap.href = `mailto:${email}`;

    document.title = `${loc.name || 'Location'} – Grill King Outdoor BBQ Kitchens`;
    renderHours(loc.schedules);
    setMap(loc);
    root.classList.add('is-ready');
    markReady();
  }

  function renderMissing() {
    if (els.name) els.name.textContent = 'Showroom not found';
    if (els.address) els.address.textContent = 'This location link may be outdated.';
    if (els.hours) {
      els.hours.innerHTML =
        '<p class="egj-location-detail__empty">Browse all showrooms or contact us for help.</p>';
    }
    if (els.mapFallback) els.mapFallback.hidden = false;
    markReady();
  }

  loadLocations().then(async (list) => {
    if (!list.length) {
      renderMissing();
      return;
    }
    let loc = alias ? list.find((item) => item.alias === alias) : null;
    // The live API can lag behind a newly corrected showroom alias. If the
    // requested store is absent there, resolve that exact alias from the theme
    // fallback before considering the link broken; never route it to list[0].
    if (alias && !loc) {
      try {
        const fallbackList = await fetchList(fallbackUrl);
        loc = fallbackList.find((item) => item.alias === alias) || null;
      } catch (e) {
        loc = null;
      }
    }
    // Only the unqualified /pages/location URL intentionally defaults to the
    // first showroom. An explicit but unknown alias must not show another store.
    if (!alias && !loc) loc = list[0];
    if (!loc) {
      renderMissing();
      return;
    }
    render(loc);
  });
})();
